import _ from "underscore";
import f from "../../../funcs";
import Backbone from "backbone";
import Marionette from "marionette";
import ContextMenuView from "../../ContextMenuView";
import UIModal from "../../modals/UIModal";
import DragDrop from "../../DragDrop";
import langDictionary from "../../lang/init";
import template from "classes/desktop/view/template/desktop_icon.html";
import "plugins/hasChild";


let index = 10;
function zIndex() {
    return index++;
}
function bigZindex() {
    return 100000;
}

let IconView = Marionette.ItemView.extend("IconView", {
    template,
    className: "icon-wrap tab-elem",
    tagName: "div",

    events: {
        //'contextmenu': "onContextmenu",
        touchstart: "touchstart",
        click: "onClick",
        dblclick: "fireOpen",
        "change textarea": "onChangeTextarea",
        "keyup textarea": "onKeyupTextarea",
        "blur textarea": "onChangeTextarea"
    },

    ui: {
        $textarea: "textarea",
        $title: ".icon-text span"
    },

    initialize(params) {
        this.desktop = params.desktop;
        this.iconsView = params.iconsView;
        this.initContextMenu();
        this.initDragDrop();
    },

    onRender() {
        this.$el.addClass("icon-mask-" + this.model.get("mask"));
        this.drawPosition();
    },

    fireOpen() {
        if ( _.isFunction(this.onOpen) && !this._move ) {
            this.onOpen();
        }
        this.trigger("open");
    },

    onOpen() {
        // default action on dblclick
        this.download();
    },

    download() {
        f.downloadFile(this.model.get("url"));
    },

    touchstart() {
        let touchstartDate = +new Date();

        if ( touchstartDate - this._touchstartDate < IconView._globalConfig.dblclickTimeout ) {
            this.fireOpen();
        }

        this._touchstartDate = touchstartDate;
    },

    initDragDrop() {
        this.dragDrop = new DragDrop();
        this.dragDrop.addElem(this.$el);
        this.dragDrop.on("start", this.onDragStart.bind(this));
        this.dragDrop.on("move", this.onDragMove.bind(this));
        this.dragDrop.on("decorateDrop", this.onDecorateDrop.bind(this));
        this.dragDrop.on("end", this.onDragEnd.bind(this));
        this.dragDrop.on("dropEnd", this.onDropEnd.bind(this));
    },

    onDecorateDrop(e) {
        let sysFiles = e.get("sysFiles");
        if ( !sysFiles ) {
            sysFiles = [];
        }

        let views = e.start.get("views") || [];
        views.forEach(function(view) {
            let id = view.model.get("ID_SYS_FILES") + "";
            if ( sysFiles.indexOf(id) == -1 ) {
                sysFiles.push(id);
            }
        });
        let id = this.model.get("ID_SYS_FILES") + "";
        if ( sysFiles.indexOf(id) == -1 ) {
            sysFiles.push(id);
        }
        e.set("sysFiles", sysFiles);
    },

    onDropEnd(e) {
        if ( e.$target.hasChild(this.$el) ) {
            return;
        }

        let x = e.start.get("x");
        let y = e.start.get("y");

        this.model.set({
            x,
            y
        });
        this.$el.css("z-index", bigZindex());
        this.drawPosition();

        let views = e.start.get("views") || [];
        views.forEach(function(view) {
            view.dragDrop.move(e.start.event, view.$el, {
                moveSelected: false
            });
        });
    },

    onDragStart(e, options) {
        if ( this.$el.hasClass("icon-rename-mode") ) {
            e.cancel();
            return;
        }

        if ( !this.$el.hasClass("selected") ) {
            this.desktop.clearSelectIcons();
            this.$el.addClass("selected");
        }

        this.dragDrop.setMover(this.$el);

        options = options || {
            startSelected: true
        };

        e.set("x", this.model.get("x"));
        e.set("y", this.model.get("y"));
        e.set("desktopIconView", this);

        let z = zIndex();
        e.set("z", z);
        this.$el.css("z-index", z);

        if ( !options.startSelected ) {
            e.cancel();
            return;
        }

        let views = this.iconsView.getSelectedViews({ without: this });
        views.forEach(function(view) {
            view.dragDrop.start(e.event, view.$el, {
                startSelected: false
            });
        }.bind(this));

        e.set("views", views);
    },

    onDragMove(e, options) {
        let x = Math.max(e.start.get("x") + e.dx, IconView._globalConfig.minx);
        let y = Math.max(e.start.get("y") + e.dy, IconView._globalConfig.miny);

        this.model.set({
            x,
            y
        });
        this.$el.css("z-index", bigZindex());
        this.drawPosition();

        options = options || {
            moveSelected: true
        };

        if ( !options.moveSelected ) {
            return;
        }

        let views = e.start.get("views") || [];
        views.forEach(function(view) {
            view.dragDrop.move(e.event, view.$el, {
                moveSelected: false
            });
        });
    },

    onDragEnd(e) {
        this.$el.css("z-index", e.start.get("z"));
        let views = e.start.get("views") || [];
        views.forEach(function(view) {
            view.$el.css("z-index", e.start.get("z"));
        });
        this.model.collection.trigger("dragStop");
    },

    drawPosition() {
        this.$el.css({
            top: this.model.get("y") + "px",
            left: this.model.get("x") + "px"
        });
    },

    initContextMenu() {
        this.contextmenuCollection = new Backbone.Collection();
        this.contextmenuCollection.set(this.getContextItems());

        this.contextmenu = new ContextMenuView({
            icon: this,
            collection: this.contextmenuCollection,
            listenElem: this.el || this.box,
            touchOpenTimeout: IconView._globalConfig.dblclickTimeout * 3
        });
        this.contextmenu.render();
    },

    getContextItems() {
        let items = [];
        if ( this.model.get("_system") ) {
            return false;
        }

        if ( this._download !== false ) {
            items.push({
                name: langDictionary.get("download"),
                onClick: function() {
                    this.download();
                    this.contextmenu.hide();
                }.bind(this)
            });
            items.push({
                name: langDictionary.get("contextmenu_open_file"),
                onClick: function() {
                    this.onOpen();
                    this.contextmenu.hide();
                }.bind(this)
            });
        }

        items.push({
            name: langDictionary.get("rename_desktop_icon"),
            onClick: function() {
                this.contextmenu.hide();
                this.beginRename();
            }.bind(this)
        });

        items.push({
            name: langDictionary.get("remove_desktop_icon"),
            onClick: function() {
                this.contextmenu.hide();
                UIModal.confirm({
                    okText: "remove_desktop_icon",
                    text: langDictionary.get("remove_desktop_icon_confirm_text"),
                    onConfirm: function() {
                        let views = this.iconsView.getSelectedViews({ without: this });
                        views.push(this);

                        views.forEach(function(view) {
                            if ( view.model && view.model.collection ) {
                                view.model.collection.remove(view.model);
                            }
                        });

                        this.destroy();
                    }.bind(this)
                });
            }.bind(this)
        });

        return items;
    },

    beginRename() {
        this.$el.addClass("icon-rename-mode");
        this.ui.$textarea.focus().select();
    },

    onChangeTextarea() {
        this.turnoffRename();
    },

    onKeyupTextarea(e) {
        if ( e.keyCode == 13 ) {
            e.preventDefault();
            this.turnoffRename();
        }
    },

    turnoffRename() {
        let newTitle = this.ui.$textarea.val();
        let oldTitle = this.model.get("title");

        if ( !newTitle || !newTitle.trim() ) {
            this.ui.$textarea.focus();
            return;
        }

        if ( oldTitle == newTitle ) {
            this.$el.removeClass("icon-rename-mode");
            return;
        }

        this.ui.$title.text(newTitle);
        this.model.set("title", newTitle);
        this.$el.removeClass("icon-rename-mode");
        this.model.collection.trigger("rename", this.model, oldTitle);
    }
});

IconView._globalConfig = {};
IconView._globalConfig.minx = 0;
IconView._globalConfig.miny = 0;
IconView._globalConfig.dblclickTimeout = 500;

IconView.plugins = {};
IconView.createPlugin = function(name, proto) {
    IconView.plugins[name] = IconView.extend(name, proto);
    return IconView.plugins[name];
};

IconView.getModelPlugin = function(model) {
    let name = model.get("plugin");
    if ( _.isFunction(IconView.plugins[name]) ) {
        return IconView.plugins[name];
    } else {
        return IconView;
    }
};

export default IconView;
